import { ImageBlock } from 'components/general/blocks/imageBlock/ImageBlock';
import {
  NewsCategoryListType,
  NewsItemCategoryType,
} from 'components/newsCategoryList/NewsCategoryList';
import Link from 'next/link';
import { widont } from 'utils/typography';
import style from './NewsItemHeader.module.scss';

export type NewsItemHeaderType = {
  blurb?: string;
  date: string;
  title: string;
  category: NewsItemCategoryType;
  slug: string;
  showLink: boolean;
  forceTitle?: boolean;
  showIntro: boolean;
};
export const NewsItemHeader = ({
  blurb,
  date,
  title,
  category,
  slug,
  showLink,
  forceTitle,
  showIntro,
}: NewsItemHeaderType): JSX.Element => {
  const titleState = forceTitle ? style.showTitleOnMobile : null;
  return (
    <Link href={slug}>
      <a className={style.link}>
        <div className={style.container}>
          <h2
            className={`${style.title} ${titleState}`}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <span className={style.details}>{category.name}</span>
          <span className={style.details}> - </span>
          <span className={style.details}>{date}</span>
          {showIntro && blurb && (
            <div className={style.text} dangerouslySetInnerHTML={{ __html: widont(blurb) }}></div>
          )}
          {showLink && <p className={style.continue}>Continue Reading</p>}
        </div>
      </a>
    </Link>
  );
};
